module.exports = __webpack_public_path__ + "img/google_logo.7a250d0f.png";